"use strict";

angular.module("core").service("common", function() {

    this.createFormDataFromFiles = function(data, fileNames) {
        var formData = new FormData();
        angular.forEach(data, function(value, name) {
            if (fileNames.indexOf(name) === -1) {
                formData.append(name, value !== null && value !== undefined ? value : ""); //Null/undefined become blank for FormData
            }
        });
        angular.forEach(fileNames, function(name) {
            var fileValue = "";
            var fileElement = angular.element("input[name='" + name + "']");
            if (fileElement.length > 0 && fileElement[0].files.length > 0) {
                fileValue = fileElement[0].files[0];
            }
            formData.append(name, fileValue);
        });
        return formData;
    };

    this.downloadFile = function(fileData, fileName, contentType) {
        // To open in IE
        if (window.navigator.msSaveOrOpenBlob && window.Blob) {
            var blob = b64toBlob(fileData, contentType);
            window.navigator.msSaveOrOpenBlob(blob, fileName); // Now the user will have the option of clicking the Save button and the Open button.
        }
        else {
            var file = "data:Application/octet-stream;base64," + encodeURIComponent(fileData);
            var hiddenLink = document.createElement("a");
            hiddenLink.setAttribute("download", fileName);
            hiddenLink.setAttribute("href", file);
            hiddenLink.setAttribute("style", "display: none");
            document.body.appendChild(hiddenLink);
            hiddenLink.click();
            document.body.removeChild(hiddenLink);
        }
    };

    this.downloadExcelFile = function(fileData, fileName) {
        return this.downloadFile(
            fileData,
            fileName,
            {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}
        );
    };

    this.getISOWeekdays = function(locale) {
        moment.locale(locale);
        return {
            1: moment.weekdays(1),
            2: moment.weekdays(2),
            3: moment.weekdays(3),
            4: moment.weekdays(4),
            5: moment.weekdays(5),
            6: moment.weekdays(6),
            7: moment.weekdays(0)
        };
    };

    this.getISOWeekdaysMapping = function() {
        return {
            1: 1,
            2: 2,
            3: 3,
            4: 4,
            5: 5,
            6: 6,
            7: 0
        };
    };

    this.scrollTo = function(query, offset) {
        var element = $(query);
        if (element.size()) {
            $("html, body").animate({scrollTop: element.offset().top + (offset ? offset : 0)}, "fast");
        }
    };

    this.scrollToTop = function() {
        $("html, body").animate({scrollTop: 0}, "fast");
    };

    this.getSortField = function(ordering) {
        return (ordering && ordering.indexOf("-") === 0) ? ordering.substring(1) : ordering;
    };

    this.getSortDirection = function(ordering) {
        return (ordering && ordering.indexOf("-") === 0) ? "-" : "";
    };

    this.getSortFieldsByKeys = function(keys, availableFields) {
        var sortFields = {};
        var fieldsSplit = keys.split(",");

        fieldsSplit.forEach(function(field) {
            sortFields[field.trim()] = availableFields[field.trim()];
        });
        return sortFields;
    };

    this.setItemOrderIndex = function(firstIndex, itemList) {
        angular.forEach(itemList, function(value, key) {
            value.orderIndex = firstIndex + key;
            value.initialOrderIndex = value.orderIndex;
        });
    };

    this.getObjectParamFromStringParamsURL = function() {
        var pairs = window.location.search.substring(1).split("&"),
            params = {},
            pair,
            i;

        for (i in pairs) {
            if (pairs[i] === "") continue;

            pair = pairs[i].split("=");
            params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
        }

        return params;
    };

    this.parseEventData = function(event) {
        try {
            return JSON.parse(event.data);
        }
        catch (e) {
            return event.data;
        }
    };

    this.parseEvent = function(event) {
        try {
            return JSON.parse(event);
        }
        catch (e) {
            return event;
        }
    };

    this.generateCombinations = function(args) {
        var r = [], max = args.length - 1;

        function loopFunction(arr, i) {
            if (!args[i]) {
                return;
            }
            for (var j = 0, l = args[i].length; j < l; j++) {
                var a = arr.slice(0);
                a.push(args[i][j]);
                if (i === max) {
                    r.push(a);
                }
                else {
                    loopFunction(a, i + 1);
                }
            }
        }

        loopFunction([], 0);
        return r;
    };
});




//////////////////
// WEBPACK FOOTER
// ./core/common/common.service.js
// module id = 409
// module chunks = 0